import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Controller from "../containers/controller_cont";
import Login from "../../auth/container/logincont";
import Register from "../../auth/container/loginotpcont";
import Assets from "../../pages/Assets/container/assetsCont";
import Admitcard from "../../pages/Assets/container/admitCardCont";
import Error from "../../404";
import Drawer_option_con from "../containers/drawer_cont";
import "./style.css";

class Routers extends Component {
  render() {
    const { login, onLogout } = this.props;
    let body;

    // ── NOT LOGGED IN — show Login / Register ──
    if (login.isHome) {
      body = (
        <div style={{ background: '#f4f6f8', minHeight: '100vh' }}>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/register" element={<Register />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </div>
      );
    }

    // ── LOGGED IN AS USER — show Registration Form (Assets) ──
    if (login.type === "User") {
      body = (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#f4f6f8' }}>
          {/* Sidebar Drawer */}
          <Drawer_option_con type={login.type} onLogout={onLogout} />

          {/* Main content pushed right on desktop */}
          <main style={{ flexGrow: 1, marginLeft: 0, marginTop: 64 }}>
            <Controller />
            <Routes>
              {/* DEFAULT: open registration form directly */}
              <Route exact path="/" element={<Admitcard />} />
              {/* <Route exact path="/register" element={<Assets />} /> */}
              <Route exact path="/admitcard" element={<Admitcard />} />
              <Route path="*" element={<Error />} />
            </Routes>
          </main>
        </div>
      );
    }

    return <Router>{body}</Router>;
  }
}

export default Routers;
